import type { HomePageModalDebugState } from "./domain/home-page/types";

export function getPostLoginAuthReady(
  modalDebugState: HomePageModalDebugState,
): boolean {
  return !!modalDebugState.userId && !modalDebugState.authLoading;
}

export function getIsTeamGalleryCoveredByDetails(input: {
  showTeamDetailsModal: boolean;
  showTeamsModal: boolean;
}): boolean {
  return input.showTeamsModal && input.showTeamDetailsModal;
}
